export default __webpack_public_path__ + "83a243e3e3fe324a40e46777fe9d1c44.svg";